import React from "react";
import { Container, Paper, Typography } from "@mui/material";

const ContactAdminTemplate = ({ type }) => {
  let title = '';
  let body = '';
  if (type === 'invoice') {
    title = 'Invoice Template Not Selected';
    body = 'No invoice template has been selected for your company yet.';
  } else if (type === 'quotation') {
    title = 'Quotation Template Not Selected';
    body = 'No quotation template has been selected for your company yet.';
  } else {
    title = 'Template Not Selected';
    body = 'No template has been selected for your company yet.';
  }
  return (
    <Container maxWidth="sm" sx={{ mt: 5, textAlign: "center" }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>{title}</Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>{body}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Please contact your administrator to configure and select a template so you can proceed.
        </Typography>
      </Paper>
    </Container>
  );
};

export default ContactAdminTemplate;
